(function () {
  var CARD_SELECTOR = ".snize-product";
  var PRODUCT_LINK_SELECTOR = 'a[href*="/products/"]';
  var BADGE_LIST_CLASS = "SnizeBadgeList";
  var badgeCache = {};

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function parseProductFromCard(card) {
    var link = card.querySelector(PRODUCT_LINK_SELECTOR);
    if (!link || !link.getAttribute("href")) return null;

    var href = link.getAttribute("href");
    var url;

    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return null;
    }

    var pathname = url.pathname || "";
    var productIndex = pathname.indexOf("/products/");
    if (productIndex === -1) return null;

    var afterProducts = pathname.slice(productIndex + "/products/".length);
    var handle = afterProducts.split("/")[0];
    if (!handle) return null;

    var rootPrefix = "";
    if (window.routes && typeof window.routes.rootUrlWithoutSlash === "string") {
      rootPrefix = window.routes.rootUrlWithoutSlash;
    }

    return {
      handle: handle,
      productPath: rootPrefix + "/products/" + handle
    };
  }

  function classifyBadge(rawBadge) {
    var normalized = rawBadge.toUpperCase();
    var compact = normalized.replace(/[\s_-]/g, "");

    if (normalized.indexOf("NEW") !== -1) return "ProductBadge--new";
    if (normalized.indexOf("SALE") !== -1) return "ProductBadge--sale";
    if (compact.indexOf("BESTSELLER") !== -1) return "ProductBadge--bestseller";
    return "";
  }

  function formatBadge(rawBadge, badgeClass) {
    if (badgeClass !== "ProductBadge--new") {
      return escapeHtml(rawBadge);
    }

    var match = rawBadge.match(/new/i);
    if (!match) return escapeHtml(rawBadge);

    var start = match.index || 0;
    var word = match[0];
    var before = escapeHtml(rawBadge.slice(0, start));
    var after = escapeHtml(rawBadge.slice(start + word.length));

    return (
      before +
      '<span class="ProductMeta__Label-word--new">' +
      escapeHtml(word) +
      "</span>" +
      after
    );
  }

  function buildBadgeMarkup(badges) {
    if (!Array.isArray(badges) || badges.length === 0) return "";

    var listClass = BADGE_LIST_CLASS;
    if (badges.length === 2) {
      listClass += " ProductBadgeList--split";
    }

    var items = badges
      .map(function (badge, index) {
        var rawBadge = (badge || "").toString().trim();
        if (!rawBadge) return "";

        var badgeClass = classifyBadge(rawBadge);
        var formattedBadge = formatBadge(rawBadge, badgeClass);
        var classes = [
          "SnizeBadge",
          "Product__Badge--metafield",
          "ProductBadge--index-" + (index + 1)
        ];

        if (badgeClass) {
          classes.push(badgeClass);
        }

        return '<span class="' + classes.join(" ") + '">' + formattedBadge + "</span>";
      })
      .filter(Boolean)
      .join("");

    if (!items) return "";
    return '<div class="' + listClass + '">' + items + "</div>";
  }

  function getBadges(productPath) {
    if (badgeCache[productPath]) return badgeCache[productPath];

    badgeCache[productPath] = fetch(productPath + "?view=searchanise-badges", {
      credentials: "same-origin"
    })
      .then(function (response) {
        if (!response.ok) return { badges: [] };
        return response.json();
      })
      .then(function (data) {
        if (!data || !Array.isArray(data.badges)) return [];
        return data.badges;
      })
      .catch(function () {
        return [];
      });

    return badgeCache[productPath];
  }

  function injectBadges(card, badges, productPath) {
    var host = card.querySelector(".snize-item") || card;
    if (!host) return;

    var existing = card.querySelectorAll("." + BADGE_LIST_CLASS);
    existing.forEach(function (node) {
      node.remove();
    });

    if (!badges || badges.length === 0) {
      card.removeAttribute("data-snize-badge-key");
      return;
    }

    var markup = buildBadgeMarkup(badges);
    if (!markup) return;

    host.insertAdjacentHTML("beforeend", markup);
    card.setAttribute("data-snize-badge-key", productPath);
  }

  function processCard(card) {
    var parsed = parseProductFromCard(card);
    if (!parsed) return;

    var currentKey = card.getAttribute("data-snize-badge-key");
    if (currentKey === parsed.productPath && card.querySelector("." + BADGE_LIST_CLASS)) {
      return;
    }

    getBadges(parsed.productPath).then(function (badges) {
      injectBadges(card, badges, parsed.productPath);
    });
  }

  function processAllCards() {
    document.querySelectorAll(CARD_SELECTOR).forEach(processCard);
  }

  var observer = new MutationObserver(function () {
    processAllCards();
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
    processAllCards();
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      observer.observe(document.body, { childList: true, subtree: true });
      processAllCards();
    });
  }
})();
